import React, { ReactNode } from "react";
import { FC } from "react";
import { Router } from "react-router-dom";
import { History } from "history";

interface IBrowserRouter {
  basename?: string;
  children: ReactNode;
  history: History;
}

export const BrowserRouter: FC<IBrowserRouter> = ({
  basename,
  children,
  history,
}) => {
  const [state, setState] = React.useState({
    action: history.action,
    location: history.location,
  });

  React.useLayoutEffect(() => history.listen(setState), [history]);

  return (
    <Router
      basename={basename}
      children={children}
      location={state.location}
      navigationType={state.action}
      navigator={history}
    />
  );
};
